import { CommonService } from "@services";
export default class DynamicDataService {
    static extractDynamicRowData(row) {
        try {
          // Attempt to parse the row as JSON
          const data = JSON.parse(row);
          // Extract rowValue and iconPath, or default to empty strings if they don't exist
          const rowValue = CommonService.htmlDecode(data?.rowValue) || "";
          const iconPath = data?.iconPath || "";
          const altText = data?.altText || "";
          const displayPrefix = data?.displayPrefix || "";
          return { rowValue, iconPath, displayPrefix, altText };
        } catch (error) {
          // If row is not a valid JSON string, treat it as a plain string
          return { rowValue: row, iconPath: "", displayPrefix: "", altText: "" };
        }
      }
}